// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1pVMC","header":"PatientBlock_header__1rPR3","label":"PatientBlock_label__w5xTe","option":"PatientBlock_option__2Jj9k"};